var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    transform: "scale(1.1, 1.1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.620552 0 0 0 0 0.020382 0 0 0 0 0.020382 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1403.000000, -118.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1403.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94230769,1.68421053 L7.61538462,1.68421053 L7.61538462,1.26315789 C7.61538462,0.565526316 7.04713942,0 6.34615385,0 L4.65384615,0 C3.95286058,0 3.38461538,0.565526316 3.38461538,1.26315789 L3.38461538,1.68421053 L1.05769231,1.68421053 C0.473555288,1.68421053 0,2.1555 0,2.73684211 L0,3.57894737 C0,3.8115 0.18940625,4 0.423076923,4 L10.5769231,4 C10.8105937,4 11,3.8115 11,3.57894737 L11,2.73684211 C11,2.1555 10.5264447,1.68421053 9.94230769,1.68421053 Z M4.23076923,1.26315789 C4.23076923,1.03105263 4.420625,0.842105263 4.65384615,0.842105263 L6.34615385,0.842105263 C6.579375,0.842105263 6.76923077,1.03105263 6.76923077,1.26315789 L6.76923077,1.68421053 L4.23076923,1.68421053 L4.23076923,1.26315789 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13687885,5 C1.05871783,5 0.996435403,5.06546951 1.00015866,5.14372561 L1.3615336,12.7454878 C1.39493341,13.4490244 1.9714907,14 2.67398169,14 L9.32601831,14 C10.0285093,14 10.6050666,13.4490244 10.6384664,12.7454878 L10.9998413,5.14372561 C11.0035646,5.06546951 10.9412822,5 10.8631212,5 L1.13687885,5 Z M7.75212093,6.09756098 C7.75212093,5.855 7.94813946,5.65853659 8.19015116,5.65853659 C8.43216287,5.65853659 8.6281814,5.855 8.6281814,6.09756098 L8.6281814,11.804878 C8.6281814,12.047439 8.43216287,12.2439024 8.19015116,12.2439024 C7.94813946,12.2439024 7.75212093,12.047439 7.75212093,11.804878 L7.75212093,6.09756098 Z M5.56196977,6.09756098 C5.56196977,5.855 5.7579883,5.65853659 6,5.65853659 C6.2420117,5.65853659 6.43803023,5.855 6.43803023,6.09756098 L6.43803023,11.804878 C6.43803023,12.047439 6.2420117,12.2439024 6,12.2439024 C5.7579883,12.2439024 5.56196977,12.047439 5.56196977,11.804878 L5.56196977,6.09756098 Z M3.3718186,6.09756098 C3.3718186,5.855 3.56783713,5.65853659 3.80984884,5.65853659 C4.05186054,5.65853659 4.24787907,5.855 4.24787907,6.09756098 L4.24787907,11.804878 C4.24787907,12.047439 4.05186054,12.2439024 3.80984884,12.2439024 C3.56783713,12.2439024 3.3718186,12.047439 3.3718186,11.804878 L3.3718186,6.09756098 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bfa1e829.svg";
export { ForwardRef as ReactComponent };